import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_MAKER_SIGN_UP_STATE_HOOKS_MIGRATION_241206 } from "@faire/web-api--source/indigofair/settings/ENABLE_MAKER_SIGN_UP_STATE_HOOKS_MIGRATION_241206";
export var useSettingEnableMakerSignUpHooksMigration = function() {
    return useSetting(ENABLE_MAKER_SIGN_UP_STATE_HOOKS_MIGRATION_241206, false);
};
